"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Experiment_1 = __importDefault(require("./Experiment"));
var When_1 = __importDefault(require("../When"));
var isReactElement = function (element) { return !!element.type; };
var isComponentClass = function (Comp) { return Comp.prototype && (Comp.prototype.render || Comp.prototype.isReactComponent); };
var getProps = function (element) { return element.props || element.attributes; };
var traverseReactTree = function (element, visitor) {
    if (Array.isArray(element)) {
        element.forEach(function (item) { return traverseReactTree(item, visitor); });
        return;
    }
    if (!element) {
        return;
    }
    if (isReactElement(element)) {
        if (typeof element.type === 'function') {
            var Comp = element.type;
            var props = Object.assign({}, Comp.defaultProps, getProps(element));
            var child = void 0;
            if (isComponentClass(Comp)) {
                var instance = new Comp(props);
                if (visitor(element) === false) {
                    return;
                }
                child = instance.render();
            }
            else {
                // a stateless functional
                if (visitor(element) === false) {
                    return;
                }
                child = Comp(props);
            }
            if (child) {
                if (Array.isArray(child)) {
                    child.forEach(function (item) { return traverseReactTree(item, visitor); });
                }
                else {
                    traverseReactTree(child, visitor);
                }
            }
        }
        else {
            // a basic dom element or string
            if (visitor(element) === false) {
                return;
            }
            if (element.props && element.props.children) {
                react_1.default.Children.forEach(element.props.children, function (child) {
                    if (child) {
                        traverseReactTree(child, visitor);
                    }
                });
            }
        }
    }
    else if (typeof element === 'string' || typeof element === 'number') {
        // Just visit these, they are leaves so we don't keep traversing.
        visitor(element);
    }
};
var getBucketsFromChildren = function (children) {
    var buckets = [];
    traverseReactTree(children, function (el) {
        if (el.type === When_1.default) {
            var bucket = el.props.bucket;
            var addBuckets = Array.isArray(bucket) ? bucket : [bucket];
            buckets = __spreadArray([], Array.from(new Set(buckets.concat(__spreadArray([], addBuckets)))));
            return false;
        }
        return !(el.type === Experiment_1.default);
    });
    return buckets;
};
exports.default = getBucketsFromChildren;
